import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'rsuite';
import { isEmpty } from 'lodash/fp';
import {
  getReservationsRememberFlagCookie,
  setReservationsRememberFlagCookie,
  getReservationsSearchQueryCookie,
  setReservationsSearchQueryCookie
} from '../../../services/currentUserCookie';

function RememberListCheckbox({ context, query }) {
  const [rememberListState, setRememberListState] = useState(
    getReservationsRememberFlagCookie(context)
  );

  const handleRememberListState = () => {
    const rememberListStateVal = !rememberListState;
    setRememberListState(rememberListStateVal);

    if (rememberListStateVal) {
      setReservationsRememberFlagCookie(context, '1');
      const queryCookie = getReservationsSearchQueryCookie(context);
      if (isEmpty(queryCookie)) {
        setReservationsSearchQueryCookie(context, query);
      }
    } else {
      setReservationsSearchQueryCookie(context, {});
      setReservationsRememberFlagCookie(context, '0');
    }
  };
  return (
    <div>
      <Checkbox checked={rememberListState} onChange={handleRememberListState}>
        Remember List State
      </Checkbox>
    </div>
  );
}

RememberListCheckbox.propTypes = {
  context: PropTypes.string.isRequired,
  query: PropTypes.shape({}).isRequired
};

export default RememberListCheckbox;
